import React from "react";
import "./RedirectionScreen.css"
import Footer from "../HomeScreen/Footer/Footer";
import { Link } from "react-router-dom";

import logoWhite from "../../image/logo/logoWhite.webp"
import Qwhite from '../../image/logo/QWhite.webp'


const RedirectionScreen = () => {

    return (
        <>
        <div className='containerRedirection primaryBack'>
            <div className="topBar">
                <Link to={"/"} className="containerLogo">
                    <img className="logoTopBar" src={logoWhite} />
                    <img className="logoTopBarTel" src={Qwhite} /> 
                </Link>
            </div>
            <div className="main">
                <div className="blockText">
                    <span className="midTextBold">Cette page n’est pas disponible.</span>
                    <span className="smallText scndText">Retourner à la page d’accueil pour continuer.</span>
                    <Link to={"/"} className="longWhiteButton smallText">Page d’accueil</Link>
                </div>
            </div>

            <Footer />
        </div>

        </>
    )
}

export default RedirectionScreen;